import {
  Avatar,
  Button,
  Stack,
  Text,
  Flex,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";
import { BsFillBellFill } from "react-icons/bs";
import RoundBackground from "./RoundBackground";
import DisplayMode from "./displayMode/DisplayMode";
import { navMarginLeftForSmallDevice } from "../../../constants";
import { useDeferredValue, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetState } from "../../../context/useGetState";
import { photoBaseURL } from "../../../service/api";
import RoundBackgroundInput from "./RoundBackgroundInput";
import notificationSound from "../../../assets/audio/notification_sound.mp3";
import { doc, getDoc, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../service/firebase";
import dayjs from "dayjs";
// RxHamburgerMenu;
import { RxHamburgerMenu } from "react-icons/rx";
import NotificationModal from "./NotificationModal";
import useSmallScreen from "../../../components/useSmallScreen";
let initialWidth = [
  window.innerWidth - 40,
  window.innerWidth - 40,
  window.innerWidth - 40,
  window.innerWidth - 230,
];

function useOutsideAlerter(ref, setOpenNotification) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
      
        setOpenNotification(false)
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export const TextLogo = ({ onToggle,isOpen }) => {
  const navigate = useNavigate();
  return (
    <>
      <Flex
        // justifyContent={"center"}
        alignItems={"center"}
        justifyContent={"space-between"}
        onClick={onToggle}
      >
        <Text
          cursor="pointer"
          fontWeight={"700"}
          fontSize="2em"
          marginRight={4}
          letterSpacing="4px"
        >
          PINDOGO
        </Text>
        <RxHamburgerMenu />
      </Flex>
    </>
  );
};
export const TextNoLogo = ({ onToggle }) => {
  const navigate = useNavigate();
  return (
    <Box
      cursor="pointer"
      onClick={onToggle}
      fontWeight={"700"}
      fontSize="2em"
      letterSpacing="4px"
    >
      <RxHamburgerMenu />
    </Box>
  );
};
function TopNav({ isOpen }) {
  const topBg = useColorModeValue("#fff", "#020b19");
  const wrapperRef = useRef(null);
 
  const { state } = useGetState();

  const { userInfo } = state;

  const userId = userInfo?.firebase_token;
  const [w, setW] = useState({
    width: "40px",
    justifyContent: "center",
    height: "40px",
    borderRadius: "50%",
    toggle: false,
  });
  const [searchText, setSearchText] = useState("");
  const deferredSearchInput = useDeferredValue(searchText);
  const [parentWidth, setParentWidth] = useState(initialWidth);
  const topBoxShadowColor = useColorModeValue("#00000042", "#000");
  const [openNotification, setOpenNotification] = useState(false);
   useOutsideAlerter(wrapperRef, setOpenNotification);

  const [smallScreen] = useSmallScreen();
  const navigate = useNavigate();
  const ref = useRef();

  const CHAT_ID = sessionStorage.getItem("CHAT_ID");
  const ROOM_ID = sessionStorage.getItem("ROOM_ID");

  useEffect(() => {
    window.addEventListener("resize", () => {
      setParentWidth([
        window.innerWidth - 40,
        window.innerWidth - 40,
        window.innerWidth - 40,
        window.innerWidth - 230,
      ]);
    });
  }, []);

  const searchRef = useRef(null);
  const increaseSearchWidth = () => {
    setW((prev) => ({
      ...prev,
      width: !prev.toggle ? "400px" : "40px",
      borderRadius: !prev.toggle ? "20px" : "50%",
      toggle: !prev.toggle,
    }));
  };

  useEffect(() => {
    // Function to handle clicks anywhere in the DOM
    const handleClickOutsideSearch = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        // Click occurred outside the search bar
        setW((prev) => ({
          ...prev,
          width: "40px",
          borderRadius: "50%",
          toggle: false,
        }));
      }
    };

    // Add a click event listener to the window
    window.addEventListener("click", handleClickOutsideSearch);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("click", handleClickOutsideSearch);
    };
  }, []);
console.log("uuesr-->", state?.userInfo?.id);
  return (
    <Stack
      ref={ref}
      className="top-navi"
      direction={"row"}
      alignItems="center"
      justifyContent={"space-between"}
      bg={topBg}
      boxShadow={`1px 1px 6px 0px ${topBoxShadowColor}`}
      ml={["-10px", navMarginLeftForSmallDevice]}
      top="0"
      // w={["100%", parentWidth]}
      w={["100%", isOpen ? parentWidth : "100%"]}
      mb="10px"
      p="5px"
      pr="10px"
      pl="30px"
      position={"fixed"}
      zIndex="999"
    >
      {!smallScreen && (
        <Stack>
          <Button
            ml={["12px", "unset"]}
            bg="#febb03"
            color={"#000000"}
            fontWeight="300"
            h={["30px", "35px"]}
            maxH={["30px", "35px"]}
            fontSize={[".8em", ".95em"]}
            size="sm"
            display={"none"}
          >
            Upgrade Account
          </Button>
        </Stack>
      )}
      {smallScreen && <TextLogo />}
      <Stack direction={"row"} alignItems="center" spacing={"10px"}>
        {!smallScreen && <DisplayMode />}
        <RoundBackgroundInput
          {...w}
          setSearchText={setSearchText}
          searchText={searchText}
          deferredSearchInput={deferredSearchInput}
          onClick={increaseSearchWidth}
          cursor={"pointer"}
          ref={searchRef} // Add a ref to the search bar
        >
          <FaSearch
            color="#2D3F7B"
            fontSize={"1.2em"}
            style={{
              flex: smallScreen & w.toggle ? ".4" : smallScreen ? "1" : "unset",
              justifySelf: "flex-end",
            }}
          />
        </RoundBackgroundInput>
        <RoundBackground>
          <div ref={wrapperRef}>
            <BsFillBellFill
              cursor={"pointer"}
              onClick={() => setOpenNotification((prev) => !prev)}
              color="#2D3F7B"
              fontSize={"1.5em"}
            />
            <NotificationModal
              setOpenNotification={setOpenNotification}
              open={openNotification}
            />
       
          </div>
        </RoundBackground>

        <RoundBackground sm mr="10px !important">
          <Avatar
            w="40px"
            h="40px"
            name={state?.userInfo?.name}
            src={state?.userInfo?.picture}
            cursor="pointer"
            onClick={() => navigate("/profile")}
          />
        </RoundBackground>
      </Stack>
    </Stack>
  );
}

export default TopNav;
